import React, { useState } from 'react'
import Image from 'next/image'
import styles from './index.module.scss'
import dayjs from 'dayjs'
import NoData from 'src/components/NoData'
import RangePickerBox from 'src/components/RangePickerBox'
import ContentLoading from 'src/components/ContentLoading'

const ImageItem = ({ imageUrl, date }) => {
  const [imageError, setImageError] = useState(false)

  return !imageError ? (
    <div className={styles.box_height} style={{ display: 'flex', justifyContent: 'center' }}>
      <div className={styles.img_box} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <span style={{ margin: '10px 0' }}>{dayjs(date).format('YYYY-MM-DD HH:mm:ss')}</span>
        <Image
          style={{ width: '100%' }}
          src={imageUrl}
          alt='img'
          width={100}
          height={100}
          onError={() => setImageError(true)}
        />
      </div>
    </div>
  ) : null
}

/**
 * @param {Object} props
 * @param {Array} props.imgData
 * @param {(range: { startTime: number, endTime: number } | null) => void} [props.onDateRangeChange]
 *   选中完整区间后回调毫秒 startTime/endTime，由上层带参请求接口；清空传 null
 * @param {boolean} [props.loading]
 */
const ContactImgBox = ({ imgData, onDateRangeChange, loading = false, scrollContainerRef }) => {
  const [selectedDates, setSelectedDates] = useState(null)

  const handleDateChange = dates => {
    if (dates?.length === 2 && dates[0] && dates[1]) {
      setSelectedDates(dates)
      onDateRangeChange?.({
        startTime: dayjs(dates[0]).startOf('day').valueOf(),
        endTime: dayjs(dates[1]).endOf('day').valueOf()
      })
    } else if (!dates || dates.length === 0) {
      setSelectedDates(null)
      onDateRangeChange?.(null)
    } else {
      setSelectedDates(dates)
    }
  }

  const handleClear = () => {
    setSelectedDates(null)
    onDateRangeChange?.(null)
  }

  return (
    <div
      ref={scrollContainerRef}
      className='relative w-full h-[calc(var(--vh2)*100-90px)] overflow-y-auto'
    >
      <div className='w-full flex justify-center mb-[20px]'>
        <RangePickerBox value={selectedDates} onChange={handleDateChange} onClear={handleClear} />
      </div>

      {loading ? (
        <div className='relative min-h-[200px] flex'>
          <ContentLoading />
        </div>
      ) : imgData.length > 0 ? (
        imgData.map((row, index) => (
          <ImageItem
            key={row.date != null ? `${row.date}-${index}` : index}
            imageUrl={`https://cos.spyx.com/${row.thumb.url}`}
            date={row.date}
          />
        ))
      ) : (
        <NoData />
      )}
    </div>
  )
}

export default ContactImgBox
